import { MMLanguageMenu } from '@components'
import KingdomBankLogo from '@images/icons/kingdom-bank-logo.svg?react'
import KingdomBankBlackLogo from '@images/kingdom-bank-icon-black.svg?react'
import settings from '@settings'
import cn from 'classnames'
import i18n from 'i18next'
import { tr, useMatchMedia } from 'mmfintech-commons'
import type { ReactNode } from 'react'
import styles from './AuthContainer.module.scss'
import AuthLeftSection from './AuthLeftSection'

type AuthContainerProps = {
  title: ReactNode
  subtitle: ReactNode
  children: ReactNode
  /**
   * Display mode for the left section
   * - 'carousel': Shows the promotional carousel (default)
   * - 'static': Shows the static image with welcome text
   * @default 'carousel'
   */
  displayMode?: 'carousel' | 'static'
}

const AuthContainer = (props: AuthContainerProps) => {
  const { title, subtitle, children, displayMode = 'carousel' } = props

  const isMobile = useMatchMedia({ breakpoint: 1400, prefix: 'max' })

  const preparePrivacyPolicyLink = () => {
    if (i18n.language === 'zh') {
      return 'https://thekingdombank.com/zh-hk/privacy-policy'
    }
    return 'https://thekingdombank.com/privacy-policy'
  }

  const prepareTermsAndConditionsLink = () => {
    if (i18n.language === 'zh') {
      return 'https://thekingdombank.com/zh-hk/terms-and-conditions'
    }
    return 'https://thekingdombank.com/terms-and-conditions'
  }

  return (
    <>
      {isMobile || displayMode === 'static' ? (
        isMobile ? (
          <KingdomBankBlackLogo className={styles['TKB-logo']} />
        ) : (
          <KingdomBankLogo className={styles['TKB-logo']} />
        )
      ) : null}

      <div className={cn(styles['auth-wrapper'], 'auth-wrapper')}>
        <section className={styles['auth-left-section']}>
          <AuthLeftSection displayMode={displayMode} title={title} subtitle={subtitle} welcomeTexts={false} />
        </section>

        <section className={styles['auth-right-section']}>
          <div className={styles['auth-language-container']}>
            <MMLanguageMenu />
          </div>

          {children}

          <div className={styles['auth-bottom-actions']}>
            <div className={styles['bottom-actions-left-side']}>
              <a href={preparePrivacyPolicyLink()}>{tr('FRONTEND.AGREEMENT.PRIVACY_POLICY', 'Privacy Policy')}</a>
              <div className='dot'></div>
              <a href={prepareTermsAndConditionsLink()}>
                {tr('FRONTEND.AGREEMENT.TERMS_AND_CONDITIONS', 'Terms and Conditions')}
              </a>
              {i18n.language === 'en' && (
                <>
                  <div className='dot'></div>
                  <a href={settings.FAQUrl}>{tr('FRONTEND.AGREEMENT.FAQ', 'FAQ')}</a>
                </>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default AuthContainer
